var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartRate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.0759 13.9986H6.95513L8.78571 11.2527C9.25951 10.5528 10.3363 10.6389 10.6702 11.425L12.7807 16.3566L15.1174 9.35749C15.4404 8.39915 16.7972 8.36682 17.1418 9.32519L19.6292 15.969L20.6199 14.483C20.8245 14.1815 21.1583 13.9985 21.5137 13.9985H29.0514C29.0514 13.9985 29.0944 14.0093 29.116 14.0093C32.0449 7.3654 28.3191 0 22.0521 0C18.5415 0 16.2373 1.98134 15.053 3.37041C13.8685 1.98134 11.5641 0 8.05386 0C1.77595 0 -1.8959 7.40848 1.01132 14.0093C1.03286 14.0093 1.05436 13.9986 1.0759 13.9986Z",
    fill: "#FF8B38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1163 16.1521L20.2857 18.898C19.8011 19.6303 18.692 19.501 18.3798 18.6827L16.2154 12.9216L13.9433 19.7271C13.631 20.6639 12.3281 20.7178 11.9296 19.8132L9.48524 14.1063L8.42996 15.6784C8.22537 15.98 7.89155 16.163 7.53619 16.163H2.17383C4.49975 19.7487 8.63471 23.3668 14.4171 27.7819C14.8048 28.0726 15.3432 28.0726 15.72 27.7819C21.5024 23.3671 25.6481 19.749 27.9633 16.163H22.0948L22.1163 16.1521Z",
    fill: "#FF8B38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartRate);
export default __webpack_public_path__ + "static/media/HeartRate.3b6a1c171bf772dc622944a0b584dc90.svg";
export { ForwardRef as ReactComponent };